import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const mainMenuItems = [
  {
    title: capitalize(i18n.t("configurations")),
    arrow: true,
    to: undefined,
    toStep: 1,
    permission: 'all',
  },
  {
    title: i18n.t("active.location"),
    arrow: true,
    to: "/admin/active-node",
    permission: 'all',
  },
  /*{
    title: i18n.t("contacts"),
    arrow: true,
    to: "/admin/config",
    permission: 'all',
  },*/
  {
    title: i18n.t("my.account"),
    arrow: true,
    to: "/admin/account",
    permission: 'all',
  },
];

export const step0 = {
  items: mainMenuItems,
  headerTitle: i18n.t("more.options"),
  navHidden: false,
  goBackTo: 0,
};
